import createIcon from '../../createIcon';

/**
 * @component @name DesktopAccessDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8xOTUyNikiPgo8cGF0aCBkPSJNMjMuNSAxNS4wOTk5QzIzLjUgMTYuMTk5OSAyMi42IDE3LjA5OTkgMjEuNSAxNy4wOTk5SDIwLjVMMTguNSAxNS4wOTk5SDIxLjVWMy4wOTk5SDYuNUw0LjUgMS4wOTk5SDIxLjVDMjIuNiAxLjA5OTkgMjMuNSAxLjk5OTkgMjMuNSAzLjA5OTlWMTUuMDk5OVpNMTUuNCAxNy4wOTk5TDIxLjQgMjMuMDk5OUwyMi43IDIxLjc5OTlMMTYgMTUuMDk5OUwxLjcgMC44OTk5MDJMMC41IDIuMTk5OUwxLjUgMy4xOTk5VjE1LjA5OTlDMS41IDE2LjE5OTkgMi40IDE3LjA5OTkgMy41IDE3LjA5OTlIMTAuNVYxOS4wOTk5SDguNVYyMS4wOTk5SDE2LjVWMTkuMDk5OUgxNC41VjE3LjA5OTlIMTUuNFpNMy41IDE1LjA5OTlWNS4xOTk5TDEzLjQgMTUuMDk5OUgzLjVaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI0MDJfMTk1MjYiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DesktopAccessDisabled = createIcon('DesktopAccessDisabled', [
  ['g', { clipPath: 'url(#clip0_2402_19526)', key: 'z55fu8' }],
  ['defs', { key: '9ahrjx' }],
]);

export default DesktopAccessDisabled;
